export default __webpack_public_path__ + "static/media/notepad.e241463b.svg";